// extracted by mini-css-extract-plugin
export default {"chat_icon_wrapper":"PageLayout_chat_icon_wrapper__FXWQF","main_wrapper":"PageLayout_main_wrapper__f4IqC"};